import {all, fork} from 'redux-saga/effects';
import appSaga from "./App/saga";
import dashboardSaga from "./Dashboard/saga";
import categoriesSaga from "./Categories/saga";
import modifiersSaga from "./Modifiers/saga";
import dishSaga from "./Dish/saga";
import inventorySaga from "./Inventory/saga";
import ordersSaga from "./Orders/saga";
import settingsSaga from "./Settings/saga";
import restaurantSaga from "./Restaurant/saga";
import menuSaga from './Menu/saga';

export default function* rootSaga() {
    yield all([
        fork(appSaga),
        fork(dashboardSaga),
        fork(categoriesSaga),
        fork(modifiersSaga),
        fork(dishSaga),
        fork(inventorySaga),
        fork(ordersSaga),
        fork(settingsSaga),
        fork(restaurantSaga),
        fork(menuSaga),
    ])
};
